<template>
  <div class="shareQr">
    <div class="content-box">
      <div v-if="showApplet" class="book-title" @click="showBook">
        <div class="qr-code">
          <img
            class="xiaochengxu"
            :src="showQrCode || require('@/assets/vip_page.png')"
            alt=""
          />
          <div class="showPublic-dec">{{lan?"Please purchase via the 'Langtou Ancient Village'(塱头古村) WeChat Mini-Program.":"会员卡仅限官方微信小程序发售"}}</div>
          <div class="showPublic-dec">{{lan?"":"请认准「塱头古村」小程序，扫码购买"}}</div>
        </div>
      </div>
      <div v-if="showHomeStay" class="book-title" @click="showBook">
        <div class="qr-code" >
          <img
            class="xiaochengxu"
            :src="showQrCode || require('@/assets/WeChatQRcode.jpg')"
            alt=""
          />
          <div class="showPublic-dec">{{lan?"Follow the 'ChunYangTai' WeChat Official Account for the latest membership news and updates.":"欢迎关注「春阳台」微信公众号"}}</div>
          <div class="showPublic-dec">{{lan?"":"获取更多会员专属资讯"}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showApplet: {
      type: Boolean,
      default: true,
    },
    showHomeStay: {
      type: Boolean,
      default: true,
    },
    showQrCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showImage: false,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  methods: {
    showBook() {
      this.showImage = !this.showImage;
    },
  },
};
</script>

<style scoped>
.book-title {
  position: relative;
  width: 322px;
  min-height: 70px;
  border-top: 1px solid #585c64;
  border-bottom: 1px solid #585c64;
  cursor: pointer;
  background-color: #fff;
}
.book-title:last-child {
  border-top: 0px solid #585c64;

}
.qr-code {
  width: 322px;
  text-align: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  letter-spacing: 0;
  font-weight: Regular;
  margin: 30px auto 20px;
}
.xiaochengxu {
  margin: 0 auto 9px;
  width: 190px;
  height: 190px;
}
.showPublic-dec {
  height: auto;
  font-size: 14px;
  line-height: 24px;
}
@media (max-width: 1440px) {
  .book-title {
    position: relative;
    width: 252px;
    min-height: 70px;
    border-top: 1px solid #585c64;
    border-bottom: 1px solid #585c64;
    cursor: pointer;
    background-color: #fff;
  }
  .qr-code {
    width: 252px;
    text-align: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    letter-spacing: 0;
    font-weight: Regular;
    margin-bottom: 28px;
  }
  .xiaochengxu {
    margin: 0 auto 9px;
    width: 160px;
    height: 160px;
  }
}
@media (max-width: 1040px) {
  .book-title {
    position: relative;
    width: 100%;
    min-height: 70px;
    border-top: 1px solid #585c64;
    border-bottom: 1px solid #585c64;
    cursor: pointer;
    background-color: #fff;
  }
  .qr-code {
    width: 100%;
    text-align: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    letter-spacing: 0;
    font-weight: Regular;
    margin-bottom: 28px;
  }
  .xiaochengxu {
    margin: 0 auto 9px;
    width: 160px;
    height: 160px;
  }
}
</style>